module.exports = __webpack_public_path__ + "img/IAR8.75f805bf.png";